import styled, { css } from 'styled-components';
import { Button, Layout } from 'antd';
import { Link } from 'react-router-dom';
import { media } from '@app/styles/themes/constants';
import { LAYOUT } from '@app/styles/themes/constants';

export const Sider = styled(Layout.Sider)`
  position: fixed;
  overflow: visible;
  right: 0;
  z-index: 5;
  min-height: 100vh;
  max-height: 100vh;

  color: var(--text-secondary-color);

  @media only screen and ${media.md} {
    right: unset;
    left: 0;

    .ant-layout-sider-children {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  }

  @media only screen and ${media.xl} {
    position: unset;
  }
`;

export const CollapseButton = styled(Button)<{ $isCollapsed: boolean }>`
  background: var(--collapse-background-color);

  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
  position: absolute;
  right: 0.5rem;

  ${(props) =>
    props.$isCollapsed &&
    css`
      right: -1rem;
    `}

  color: var(--text-secondary-color);

  &:hover {
    color: var(--text-secondary-color);
    background: var(--primary-color);
    border: 1px solid var(--border-color);
  }

  &:focus {
    color: var(--text-secondary-color);
    background: var(--primary-color);
    border: 1px solid var(--border-color);
  }
`;

export const SiderContent = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - ${LAYOUT.mobile.headerHeight});

  @media only screen and ${media.md} {
    flex: 1;
    min-height: 0;
    max-height: unset;
  }
`;

export const SiderProfileSection = styled.div<{ $isCollapsed: boolean }>`
  display: none;

  @media only screen and ${media.md} {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0.75rem 1.5rem;
    border-top: 1px solid var(--border-color);

    ${({ $isCollapsed }) =>
      $isCollapsed &&
      css`
        padding: 0.75rem 0.5rem;

        .ant-col + .ant-col {
          display: none;
        }
      `}
  }
`;

export const SiderLogoLink = styled(Link)`
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;

  .ant-avatar-circle {
    min-width: 48px;
  }
`;

export const SiderLogoDiv = styled.div`
  height: ${LAYOUT.mobile.headerHeight};
  padding: ${LAYOUT.mobile.headerPadding};
  display: flex;
  justify-content: space-between;
  align-items: center;

  img.ant-image-img {
    width: 15px;
    position: absolute;
    left: -0.5rem;
    top: 0.2rem;
  }

  @media only screen and ${media.md} {
    height: ${LAYOUT.desktop.headerHeight};
    padding-top: ${LAYOUT.desktop.paddingVertical};
    padding-bottom: ${LAYOUT.desktop.paddingVertical};
  }
`;

export const BrandSpan = styled.span`
  margin: 0 1rem;
  font-weight: 700;
  font-size: 1.125rem;
  color: var(--white);
`;

export const Brand = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 0.5rem;

  @media only screen and ${media.md} {
    margin-left: 1rem;
  }
  @media only screen and ${media.lg} {
    margin-left: 0.5rem;
  }
  @media only screen and ${media.xl} {
    margin-left: 1rem;
  }
  @media only screen and ${media.xxl} {
    margin-left: 0.5rem;
  }
`;
